import eyecare from "assets/images/banners/home/optho.png";
import aboutus from "assets/images/banners/about/optho.png";
import facility from "assets/images/banners/facility/optho.png";
import facility2 from "assets/images/banners/facility/wavelight.png";
import info from "assets/images/banners/info/optho.png";

export const data = {
  id: "department", 
  label: "Ophthalmology",
  banner: "Expert Eye Care || Restoring Vision, Transforming Lives",
  bannerSize: ["4.375rem", "2.375rem"],
  bannerImg: eyecare,
  aboutImg: aboutus,
  title: "Find the Best Eye Specialist in Chennai – Expert Ophthalmologists",
  description: "Amrit Hospitals offers top-notch eye care services in Chennai. From routine check-ups to advanced treatments, trust our experienced ophthalmologists.",
  keyword: "eye specialist in Chennai",
  url: "https://www.amrithospitals.com/department/opthomology",
  Imageme: "https://www.amrithospitals.com/static/media/optho.966f29f85f82f47f8c43.png",
  about: [ 
    {
      text: "40+",
      subText: "Years of Experience",
    },
    {
      text: "2 Lac+",
      subText: "Surgeries",
    },
    {
      text: "4.8 Lac+",
      subText: "Happy Patients",
    },
    {
      text: "25000+",
      subText: "Specs Removed",
    },
  ],
  facilityImg: facility,
  infoImg: info,
  info: {
    heder: "Powered By",
    subheader: "Artificial Intelligence",
    point1: "NO BLADE, NO PAIN",
    point2: "NO STITCH, NO INJECTION",
  },
  facility: {
    mainHeader: "Freedom From Glasses In Just 9 Seconds",
    subHeader: "Smile Pro Surgery can be life changing",
    content:
      "Dreamed of becoming a pilot, a model, or anything you've ever desired? In just 9 seconds, Smile Pro Surgery can remove your specs and change your life forever. Embrace a future of limitless possibilities with crystal-clear vision!",
  },
  facilityImg2: facility2,
  facility2: {
    mainHeader: "WaveLight Plus InnovEyes Technology",
    subHeader: "AI-Guided, Ultra Fast, Pain-Free Vision Correction",
    content:
      "Tired of depending on glasses or contact lenses? Get your vision corrected in just 15 seconds per eye with an AI-guided, laser procedure that delivers unmatched precision and safety. Experience faster recovery and clearer sight — all within 24 hours.",
  },
  serviceHeader: "Super-Specialty Eye Care",
  services: [

    {
      id: "WaveLightPlusInnovEyesTechnology",
      label: "WaveLight Plus InnovEyes Technology",
      content:
        "Step into the future of eye health with AI-guided vision correction that combines speed, precision, and comfort like never before.",
        customLink: "/wavelight-plus",
    },
    {
      id: "smileProSurgery",
      label: "Smile Pro Surgery",
      content:
        "Experience the world's first robotic, flapless, and minimally invasive laser vision correction procedure, restoring perfect vision in just 9 seconds.",
    },
    {
      id: "contouraVision",
      label: "Contoura Vision - Specs Removal",
      content:
        "Achieve superior visual acuity with this advanced LASIK technique that customizes treatment based on the microscopic contours of your cornea.",
    },
    {
      id: "cataract",
      label: "Cataract",
      content:
        "Restore clarity and improve vision with our advanced cataract surgery options, ensuring a brighter, clearer future.",
    },
    {
      id: "glaucoma",
      label: "Glaucoma",
      content:
        "Protect your vision with our comprehensive glaucoma management and treatment plans, tailored to prevent and control eye pressure.",
    },
    {
      id: "corneaAndKeratoconus",
      label: "Cornea and Keratoconus",
      content:
        "Specialized care for corneal diseases and keratoconus, offering treatments to improve corneal health and visual outcomes.",
    },
    {
      id: "pediatricOphthalmology",
      label: "Pediatric Ophthalmology",
      content:
        "Dedicated eye care for children, addressing vision issues early to ensure optimal eye health and development.",
    },
    {
      id: "retina",
      label: "Retina",
      content:
        "Advanced diagnostic and treatment options for retinal conditions, preserving and enhancing your vision with cutting-edge care.",
    },
    {
      id: "oculoplastyAndCosmeticEnhancement",
      label: "Oculoplasty and Cosmetic Enhancement",
      content:
        "Enhance your appearance and eye function with our expert oculoplastic and cosmetic procedures.",
    },
    {
      id: "contactLenses",
      label: "Contact Lenses",
      content:
        "Find the perfect contact lenses to suit your lifestyle and visual needs, with personalized fitting and care.",
    },
    {
      id: "neuroOphthalmology",
      label: "Neuro Ophthalmology",
      content:
        "Specialized care for complex eye conditions related to the nervous system, ensuring comprehensive diagnosis and treatment.",
    },
    {
      id: "lowVisionSyndrome",
      label: "Low Vision Syndrome",
      content:
        "Customized solutions to improve quality of life and maximize remaining vision for those with low vision syndrome.",
    },
  ],
};
